module.exports = __webpack_public_path__ + "img/mockup-move-apps-IT.622bf511.png";